<template>
  <div>
    <div class="row">
      <div class="flex xs10 offset--xs1">
        <va-card :title="title">
          <div class="row">
            <div class='flex md12 sm6 xs12'>
              <va-button
                outline
                color="success"
                @click="translateUnfilledFields"
              >一件翻译绿色Field</va-button>
            </div>
            <div class='flex md12 sm6 xs12' v-if="showId">
              <va-input
                v-model='postId'
                label='postID'
                disabled
              />
            </div>
            <div class="flex md6 sm6 xs6">
              <va-select
                v-model="insertData.uid"
                label="用户名"
                textBy="nickname"
                :options="libaUserNicknames"
                searchable
                width="350px"
              />
            </div>
            <div class="flex md6 sm6 xs6">
              <va-select
                label="面试干货标签"
                v-model="insertData.interviewTagNames"
                multiple
                :options="computeInterViewTags"
              />
            </div>
            <div class='flex md12 sm6 xs12' v-show="insertData.coverUrl.length!==0">
              <va-card
                overlay
                :image='insertData.coverUrl'
                class="va-card-image"
              >
              </va-card>
            </div>
            <div class="flex md12 sm6 xs12">
              <va-card title='封面展示图'>
                <va-file-upload
                  type='single'
                  v-model='insertData.coverUrlArr'
                  @input="uploadImage"
                />
              </va-card>
            </div>
            <div class="flex md12 sm6 xs12">
              <va-select
                label="精选类型"
                v-model="insertData.type"
                :options="typeOptions"
              />
            </div>
            <div class="flex md12 sm6 xs12">
              <va-input
                v-model="insertData.title"
                label="标题"
                removable
              />
            </div>
            <div class="flex md12 sm6 xs12">
              <va-input
                v-model="insertData.titleEn"
                label="标题(英文)"
                removable
                success
              />
            </div>
            <div class="flex md12 sm6 xs12" v-if="insertData.type==='图文'">
              <va-input
                v-model="insertData.desc"
                label="简短描述"
                type="textarea"
                removable
              />
            </div>
            <div class="flex md12 sm6 xs12" v-if="insertData.type==='图文'">
              <va-input
                v-model="insertData.descEn"
                label="简短描述(英文)"
                type="textarea"
                removable
                success
              />
            </div>
            <div class="flex md12 sm6 xs12">
              <va-button flat small>精选内容</va-button>
              <vue-trix
                v-model="insertData.content"
                placeholder="精选内容"
                :config="captionConfig"
                @trix-attachment-add="handleAttachmentChanges"
              />
            </div>
            <div class="flex md12 sm6 xs12">
              <va-button color=success  small>精选内容(英文)</va-button>

              <vue-trix
                v-model="insertData.contentEn"
                placeholder="精选内容(英文)"
                :config="captionConfig"
                @trix-attachment-add="handleEnAttachmentChanges"
              />
            </div>
            <div class="flex md12 sm6 xs12" v-if="insertData.type==='视频'">
              <va-input
                v-model="insertData.videoUrl"
                label="视频url"
                :messages="['请在下方OSS云端视频列表中选择']"
                removable
                disabled
              />
            </div>
            <div class='flex md12 sm6 xs12' v-show="insertData.videoUrl.length!==0 && insertData.type==='视频'" >
              <video
                :src="insertData.videoUrl"
                loop="loop"
                width="500px"
                controls="controls"
                class="section-background-video"
              >
                <source
                  type="video/mp4"
                  :src="insertData.videoUrl"
                />
              </video>
            </div>
            <div class="flex md12 sm6 xs12" v-if="insertData.type==='视频'">
              <va-input
                v-model="insertData.videoUrlEn"
                label="视频url(英文)"
                :messages="['请在下方OSS云端视频列表中选择']"
                removable
                disabled
                success
              />
            </div>
            <div class='flex md12 sm6 xs12' v-show="insertData.videoUrlEn.length!==0 && insertData.type==='视频'" >
              <video
                :src="insertData.videoUrlEn"
                loop="loop"
                width="500px"
                controls="controls"
                class="section-background-video"
              >
                <source
                  type="video/mp4"
                  :src="insertData.videoUrlEn"
                />
              </video>
            </div>
            <div class="flex md12 sm6 xs12">
              <va-input
                v-model="insertData.sortNum"
                label="排序"
                placeholder="数字越大越靠前"
                removable
                :messages="message"
                :error="!!error.sortNumErrors.length"
                :error-messages="error.sortNumErrors"
                type="number"
                :min="1"
                oninput="if(value <0)value=1"
              />
            </div>
          </div>

          <div class='flex md2 offset--md5'>
            <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
              submit
            </va-button>
          </div>

        </va-card>
      </div>
    </div>
    <div class="row" v-if="insertData.type==='视频'">
      <div class="flex xs10 offset--xs1">

        <va-card title="OSS云端视频列表">
          <div class="flex md6 xs12 sm6">
            <va-input
              class="ma-0"
              :value="originalName"
              placeholder="搜索视频名称"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <va-data-table
            :fields="fields"
            :data="ossFiles"
            :loading="loading"
            api-mode
          >
            <template slot="actions" slot-scope="props">
              <va-button
                small
                color="info"
                @click="selectVideo(props.rowData.url)"
                v-if="insertData.videoUrl === props.rowData.url">选择视频</va-button>
              <va-button
                small
                outline
                color="info"
                @click="selectVideo(props.rowData.url)"
                v-else>选择视频</va-button>
              <va-button
                small
                color="info"
                @click="selectVideoEn(props.rowData.url)"
                v-if="insertData.videoUrlEn === props.rowData.url">选择英文视频</va-button>
              <va-button
                small
                outline
                color="info"
                @click="selectVideoEn(props.rowData.url)"
                v-else>选择英文视频</va-button>
            </template>
          </va-data-table>

        </va-card>
      </div>
    </div>
  </div>

</template>

<script>

import 'vue-trix'
import { copyObject, formatTime, getTagIds, translateData } from '@/utils/common'
import postApi from '../../api/interview/post'
import uploadApi from '../../api/upload'
import tagApi from '../../api/tag'
import { TAG_TYPE } from '@/utils/constants'
import userApi from '../../api/user'
import ossApi from '@/api/oss'
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      postId: null,
      insertData: {
        postId: null,
        uid: '',
        name: '',
        sortNum: 1,
        coverUrl: '',
        coverUrlArr: [],
        type: '',
        title: '',
        titleEn: '',
        videoUrl: '',
        videoUrlEn: '',
        content: '',
        contentEn: '',
        desc: '',
        descEn: '',
        interviewTagNames: [],
      },
      message: ['Required field'],
      error: {
        sortNumErrors: [],
      },
      title: '新增精选内容',
      showId: false,
      submitButtonStatus: true,
      typeOptions: ['图文', '视频'],
      allTags: [],
      captionConfig: {
        attachments: {
          preview: {
            caption: {
              name: false,
              size: false,
            },
          },
        },
      },
      libaUsers: [],
      libaUserNicknames: [],
      videoUploadPercent: 0,
      videoFlag: false,
      ossFiles: [],
      originalName: '',
      loading: false,
      selectedUrl: '',
    }
  },
  created () {
    const params = this.$route.params
    this.postId = params.postId
    if (params.postId != null) {
      this.showId = true
      this.title = '编辑精选内容'
      // 通过id获取详情
      postApi.getPost(params.postId).then(response => {
        copyObject(response, this.insertData)
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('type')) {
          if (response.type === 1) {
            this.insertData.type = '图文'
          } else {
            this.insertData.type = '视频'
          }
        }
        // 设置tag
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('tags')) {
          this.insertData.interviewTagNames = response.tags.map(tag => { return tag.name })
        }
        // 设置uid
        this.insertData.uid = {
          id: response.uid,
          nickname: response.nickname + ' (' + response.uid + ')',
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
    // 列出面试干货标签
    this.listInterviewTag()
    // 加载liba用户
    this.listLibaUser()
    this.listOssLargeFile()
  },
  computed: {
    fields () {
      return [
        {
          name: 'originalName',
          title: '原名称',
          width: '25%',
        },
        {
          name: 'url',
          width: '25%',
        },
        {
          name: 'createTime',
          title: '同步时间',
          width: '25%',
        },
        {
          name: '__slot:actions',
          width: '25%',
          dataClass: 'text-left',
        },
      ]
    },
    formReady () {
      return !this.error.sortNumErrors.length
    },
    computeInterViewTags () {
      return this.allTags.map(tag => {
        return tag.name
      })
    },
  },
  methods: {
    listOssLargeFile () {
      const params = {
        originalName: this.originalName,
      }
      ossApi.listOssLargeFile(params).then(response => {
        this.ossFiles = response.ossFiles
        this.ossFiles.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    selectVideo (url) {
      this.insertData.videoUrl = url
    },
    selectVideoEn (url) {
      this.insertData.videoUrlEn = url
    },
    search: debounce(function (originalName) {
      this.originalName = originalName
      this.listOssLargeFile()
    }, 400),
    listLibaUser () {
      const params = {
        pageNumber: 1,
        pageSize: 100000,
      }
      userApi.listUser(params)
        .then(response => {
          this.libaUsers = response.users
          this.libaUserNickname()
        })
    },
    libaUserNickname () {
      const nicknames = []
      for (let i = 0; i < this.libaUsers.length; i++) {
        const item = {}
        item.id = this.libaUsers[i].uid
        item.nickname = this.libaUsers[i].nickname + ' (' + item.id + ')'
        nicknames.push(item)
      }
      console.log(nicknames)
      this.libaUserNicknames = nicknames
    },
    listInterviewTag () {
      tagApi.listTag({ tagType: TAG_TYPE.COURSE_TAG.CODE }).then(response => {
        this.allTags = response.tags
      }).catch(error => {
        console.log(error)
      })
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      if (this.insertData.coverUrl === '') {
        this.changeButtonStatus(true)
        this.showToast('请上传图片', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      const data = {
        uid: this.insertData.uid.id,
        desc: this.insertData.desc,
        descEn: this.insertData.descEn,
        coverUrl: this.insertData.coverUrl,
        title: this.insertData.title,
        titleEn: this.insertData.titleEn,
        sortNum: this.insertData.sortNum,
        tagIds: getTagIds(this.allTags, this.insertData.interviewTagNames),
      }
      if (this.insertData.type === '图文') {
        data.type = 1
        data.content = this.insertData.content
        data.contentEn = this.insertData.contentEn
        data.desc = this.insertData.desc
        data.descEn = this.insertData.descEn
      } else if (this.insertData.type === '视频') {
        data.type = 2
        if (this.insertData.videoUrl === '') {
          this.changeButtonStatus(true)
          this.showToast('请上传视频', {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
          return
        }
        data.videoUrl = this.insertData.videoUrl
        data.videoUrlEn = this.insertData.videoUrlEn
        data.content = this.insertData.content
        data.contentEn = this.insertData.contentEn
      }
      console.log(this.insertData)
      if (this.insertData.postId !== null) {
        data.postId = this.insertData.postId
        postApi.updatePost(this.postId, data).then(response => {
          if (response.success === true) {
            this.showToast('面经干货更新成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listPost' })
          }
          this.$router.push({ name: 'listPost' })
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error.msg)
        })
      } else {
        postApi.createPost(data).then(response => {
          if (response.success === true) {
            this.showToast('面经干货添加成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listPost' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error.msg)
        })
      }
    },
    checkField () {
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    uploadImage () {
      if (this.insertData.coverUrlArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', this.insertData.coverUrlArr[this.insertData.coverUrlArr.length - 1])
      uploadApi.uploadImage(formData).then(response => {
        console.log(response)
        this.insertData.coverUrl = response.url
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    handleAttachmentChanges (event) {
      const file = event.attachment.file
      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', file)
      uploadApi.uploadImage(formData).then(response => {
        event.attachment.setAttributes({ url: response.url })
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        console.log(error)
      })
    },
    handleEnAttachmentChanges (event) {
      const file = event.attachment.file
      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', file)
      uploadApi.uploadImage(formData).then(response => {
        event.attachment.setAttributes({ url: response.url })
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        console.log(error)
      })
    },
    async translateUnfilledFields () {
      // 标题
      if (this.insertData.title !== '' && this.insertData.titleEn === '') {
        this.insertData.titleEn = await translateData(this.insertData.title)
      }
      // 精选内容
      if (this.insertData.content !== '' && this.insertData.contentEn === '') {
        this.insertData.contentEn = await translateData(this.insertData.content)
      }
      // 简短描述
      if (this.insertData.type === '图文' && this.insertData.desc !== '' && this.insertData.descEn === '') {
        this.insertData.descEn = await translateData(this.insertData.desc)
      }
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
